import React, { useState } from 'react';
import { Box, Collapse, Chip, Stack } from '@mui/material';
import { Settings, Package, Thermometer, DoorOpen, KeyRound, PenLine } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SpecialOptionsForm } from './forms/SpecialOptionsForm';
import { SectionHeader } from './SectionHeader';

export const SpecialOptionsSection = ({
  returnParcels,
  setReturnParcels,
  returnMethod,
  setReturnMethod,
  temperatureControl,
  setTemperatureControl,
  canBeLeftAtDoor,
  setCanBeLeftAtDoor,
  requiresPin,
  setRequiresPin,
  requiresSignature,
  setRequiresSignature,
  inModal = false,
}) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const activeChips = [
    { key: 'canBeLeftAtDoor',    active: canBeLeftAtDoor,    icon: <DoorOpen size={12} />,    label: t('delivery.canBeLeftAtDoor')    || 'Leave at Door' },
    { key: 'returnParcels',      active: returnParcels,      icon: <Package size={12} />,     label: t('delivery.returnParcels')      || 'Returns' },
    { key: 'temperatureControl', active: temperatureControl, icon: <Thermometer size={12} />, label: t('delivery.temperatureControl') || 'Temp Control' },
    { key: 'requiresPin',        active: requiresPin,        icon: <KeyRound size={12} />,    label: t('delivery.requiresPin')        || 'PIN' },
    { key: 'requiresSignature',  active: requiresSignature,  icon: <PenLine size={12} />,     label: t('delivery.requiresSignature')  || 'Signature' },
  ].filter(o => o.active);

  const subtitle = activeChips.length > 0
    ? activeChips.map(o => o.label).join(' · ')
    : (t('delivery.noOptionsSelected') || 'None selected');

  return (
    <Box>
      <SectionHeader
        icon={<Settings size={16}  />}
        title={t('delivery.specialOptions') || 'Special Options'}
        subtitle={subtitle}
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
        inModal={inModal}
      />

      {!expanded && activeChips.length > 0 && (
        <Box sx={{ pl: inModal ? 3.5 : 4.5, pt: 0.5, pb: 1 }}>
          <Stack direction="row" flexWrap="wrap" gap={0.75}>
            {activeChips.map((opt) => (
              <Chip
                key={opt.key}
                icon={opt.icon}
                label={opt.label}
                size="small"
                variant="outlined"
                sx={{ height: 24, fontSize: '0.75rem', '& .MuiChip-icon': { ml: '6px' }, '& .MuiChip-label': { px: 1 } }}
              />
            ))}
          </Stack>
        </Box>
      )}

      <Collapse in={expanded}>
        <Box sx={{ pl: inModal ? 3.5 : 4.5, pt: 1, pb: 1 }}>
          <SpecialOptionsForm
            returnParcels={returnParcels}
            setReturnParcels={setReturnParcels}
            returnMethod={returnMethod}
            setReturnMethod={setReturnMethod}
            temperatureControl={temperatureControl}
            setTemperatureControl={setTemperatureControl}
            canBeLeftAtDoor={canBeLeftAtDoor}
            setCanBeLeftAtDoor={setCanBeLeftAtDoor}
            requiresPin={requiresPin}
            setRequiresPin={setRequiresPin}
            requiresSignature={requiresSignature}
            setRequiresSignature={setRequiresSignature}
          />
        </Box>
      </Collapse>
    </Box>
  );
};